import { render, staticRenderFns } from "./WisdomTable.vue?vue&type=template&id=17254b92"
import script from "./WisdomTable.vue?vue&type=script&lang=js"
export * from "./WisdomTable.vue?vue&type=script&lang=js"
import style0 from "./WisdomTable.vue?vue&type=style&index=0&id=17254b92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports